/**
 =========================================================
 * Material Dashboard 2 React - v2.2.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2023 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

import * as React from 'react';

// @mui material components
import Grid from "@mui/material/Grid";
import { useEffect, useState } from "react";
import Icon from "@mui/material/Icon";
import MDButton from "../../components/MDButton";
import DataTable from "../../examples/Tables/DataTable";
import useApi from "../../components/Utils/api";
import data from "../dashboard/components/Projects/data";
import MDBox from "../../components/MDBox";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Dialog from "@mui/material/Dialog";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import toast from "utils/toast";
import Papa from 'papaparse';

function ResetPin() {
  const [users, setUsers] = useState([]);
  const [user, setUser] = useState({});
  const { mposUsersTablecolumns } = data();
  const [openPasswordDialog, setOpenPasswordDialog] = useState(false);
  const api = useApi();

  useEffect(() => {
      getAllMposUsers();
  }, []);
    const resetAppPassword = (item) => {
        setOpenPasswordDialog(true);
        setUser(item);
    }
    const getAllMposUsers = () => {
        const data = {
            userId: '',
            groupMid: '',
            referenceId: '',
            mobileNo: ''
        }
        api.post("/submerchant/browse", data)
            .then(response => {
              if(response.data.statusCodeValue === 200) {
                const modifiedData = response.data.body.map(item => {
                  const action = (
                      <MDBox display="flex" alignItems="center" lineHeight={1}>
                        <Icon title="Reset App Password" fontSize="small" style={{cursor : 'pointer'}} onClick={() => resetAppPassword(item)}>lock_reset</Icon>
                      </MDBox>
                  );
                  return { ...item, action };
                });
                  setUsers(modifiedData);
              }
              console.log(response)
            })
            .catch(error => {
              console.log(error)
            })
    }

    const handlePasswordResetSubmit = () => {
        const data = {
            userId: user.userId
        }
        api.post("/utils/resetapppassword", data)
            .then(response => {
                if (response.data.statusCodeValue === 200) {
                    toast.success(response.data.body);
                    setOpenPasswordDialog(false);
                    setUser({});
                    getAllMposUsers();
                }
            })
            .catch(error => {
                if(error.response.data.body){
                    toast.error(error.response.data.body);
                }

            })
    }

    const generateCSV = () => {
      if (users.length === 0) {
        return '';
      }
  
      const headers = mposUsersTablecolumns
        .filter(column => column.Header !== "Action")
        .map(column => column.Header);
  
      const usersWithoutAction = users.map(item => {
        return mposUsersTablecolumns
          .filter(column => column.Header !== "Action")
          .map(column => {
            const accessor = column.accessor;
            const value = typeof accessor === 'function' ? accessor(item) : item[accessor];
            return value;
          });
      });
  
      const csvData = [headers, ...usersWithoutAction];
  
      const csv = Papa.unparse(csvData, {
        quotes: true,
      });
  
      return csv;
    };
  
    const handleDownloadCSV = () => {
      if (users.length === 0) {
        toast.error("No records found to download.");
        return;
      }
  
      const csvData = generateCSV();
  
      const currentDate = new Date().toISOString().slice(0, 10);
      const currentTime = new Date().toLocaleTimeString().replace(/:/g, '-');
      const dateTimeString = `${currentDate}_${currentTime}`;
  
      const fileName = `ResetPin_${dateTimeString}.csv`;
  
      const blob = new Blob([csvData], { type: 'text/csv' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    };

    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox mt={6} mb={3}>
            <Grid container spacing={3} justifyContent="center">
                <Grid item xs={12} lg={12}>
                <MDButton variant="gradient" onClick={handleDownloadCSV} color="info" style={{marginRight: "24px", marginBottom: "12px"}}>
                  Export
              </MDButton>
                    <DataTable
                        table={{ columns : mposUsersTablecolumns, rows : users }}
                        showTotalEntries={true}
                        isSorted={true}
                        noEndBorder
                        entriesPerPage={true}
                        hideExpandColumn={true} 
                        canSearch={true}
                    />
                </Grid>
          </Grid>
        </MDBox>
      <Dialog disableEscapeKeyDown open={openPasswordDialog} onClose={() => setOpenPasswordDialog(true)}>
          <DialogTitle>Reset App Password</DialogTitle>
          <DialogContent>
              <Typography fontSize="medium">Do you really want to reset the App password for user <Typography fontSize="medium" fontWeight="bold">{user?.userId}</Typography></Typography>
          </DialogContent>
          <DialogActions>
              <Button onClick={() => {
                setOpenPasswordDialog(false);
                setUser({});
              }
              }>Cancel</Button>
              <Button onClick={handlePasswordResetSubmit}>Ok</Button>
          </DialogActions>
      </Dialog>
      </DashboardLayout>
  );
}

export default ResetPin;
